import "../App.css";
import { useStoreState } from "@zf/react-frontend-vite";
import { botStore } from "@zf/react-frontend-vite";
import { useEffect, useState, useRef } from "react";

function RaiseTicketComponent({ workflowName, buttonText }) {
  const connectedStore = useStoreState();
  const botProps = botStore.getState();

  const [language, setLanguage] = useState(
    navigator.language || navigator.userLanguage
  );

  const buttonRef = useRef(null);

  const triggerWorkflow = () => {
    if (connectedStore?.storeState) {
      connectedStore?.storeState?.dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "WORKFLOW",
          value: workflowName,
        },
      });

      const parent = buttonRef.current?.parentNode;
      if (parent) {
        parent.classList.add("hidden");
      }
    }
  };

  useEffect(() => {
    setLanguage(botProps.connectionReducer.language);
  }, [botProps.connectionReducer.language]);

  return (
    <div
      ref={buttonRef}
      className="raiseTicketButton"
      onClick={triggerWorkflow}
    >
      <p>{language.slice(0, 2) === "de" ? buttonText.de : buttonText.en}</p>
    </div>
  );
}
export default RaiseTicketComponent;
